/*
 * 文件模板管理模块
 */

// 认证信息
export function filePage() {
  return {
    url: 'file/page',
    method: 'get',
    data: {
      'code': 200,
      'data': {
        endRow: 10,
        hasNextPage: true,
        hasPreviousPage: false,
        isFirstPage: true,
        isLastPage: false,
        list: [
          { id: 'WD202105149609256824', a: 'CDA001', b: '个人基本健康信息登记', c: '共享文档规范'},
          { id: 'WD202105149609256347', a: 'CDA002', b: '出生医学证明', c: '共享文档规范'},
          { id: 'WD202105149609256789', a: 'CDA003', b: '新生儿家庭访视', c: '共享文档规范'},
          { id: 'WD202105149609256365', a: 'CDA004', b: '儿童健康体检', c: '共享文档规范'},
          { id: 'WD202105149609256789', a: 'CDA005', b: '首次产前随访服务', c: '共享文档规范'},
          { id: 'WD202105149609256024', a: 'CDA006', b: '产前随访服务', c: '共享文档规范'},
          { id: 'WD202105149609256524', a: 'CDA007', b: '产后访视', c: '共享文档规范'},
          { id: 'WD202105149609256324', a: 'CDA008', b: '产后42天健康检查', c: '共享文档规范'},
          { id: 'WD202105149609258824', a: 'CDA009', b: '预防接种疫苗', c: '共享文档规范'},
          { id: 'WD202105149609226824', a: 'CDA010', b: '传染病报告', c: '共享文档规范'},
        ],
        navigateFirstPage: 1,
        navigateLastPage: 8,
        navigatePages: 8,
        nextPage: 2,
        pageNum: 1,
        pageSize: 10,
        pages: 1,
        prePage: 0,
        size: 10,
        startRow: 1,
        total: 10,
      },
      'msg': '模板信息'
    }
  }
}


// WEBPACK FOOTER //
// ./src/mock/modules/template.js